import React from 'react';
import { TableCell } from '@material-ui/core';

interface RankCellProps {
  value: number,
  podiumNr: number
}

export default function RankCell({ value, podiumNr }: RankCellProps) {
  return (
    <TableCell style={ { width: '60px' } }>
      {
        value >= 0 && (
          <div className={
            value <= podiumNr ? 'competitors-table__ranking competitors-table__ranking-box' : 'competitors-table__ranking'
          }
          >
            { value }
          </div>
        )
      }
    </TableCell>
  );
}
